<template>
  <v-dialog
    v-model="dialog_proof"
    flat
    persistent
    max-width="900"
    content-class="br_none"
  >
    <v-card class="br_none modal_comfirm_wrap type4">
      <v-btn class="modal_close" @click="fnClose()" fab color="white">
        <v-icon dark>mdi-close</v-icon>
      </v-btn>
      <h2 class="header_title02 type4">{{ $t('signin.proof_document.fields.upload_proof_of_document') }}</h2>
    </v-card>
    <v-layout class="login_wrap type2 modal_type">
      <v-flex class="pa-0 login_content type2 ma-0">
        <v-card class="login_form type2 type3" flat>
          <v-card-text class="pa-0 inner_item_content bd_none ma-0">
            <ValidationObserver ref="observer">
              <v-form>
                <!-- ID Card or Passport -->
                <v-row class="ma-0 mb-15" v-if="user_group_type_code === '3802' || user_group_type_code === '3804'">
                  <v-col class="pa-0">
                    <h2 class="nec_title mb-15"><i>*</i> {{ $t('signin.proof_document.fields.company_registration_documents') }}</h2>
                    <div class="input_text_type_basic file_type">
                      <ValidationProvider v-slot="{ errors }" :name="$t('signin.proof_document.fields.company_registration_documents')" :rules="{required: true}">
                        <v-file-input
                          outlined
                          dense
                          :placeholder="$t('common.common.no_files_selected')"
                          :prepend-icon="$t('common.common.select_file')"
                          class="ft-size12"
                          accept=".pdf, .jpg, .gif"
                          v-model="company_reg_file"
                          style="height: 40px"
                          :error-messages="errors"
                          @change="fnUploadCompanyRegFile()"
                          clearable
                          @click:clear="fnInitCompanyRegFile()"
                        >
                        </v-file-input>
                      </ValidationProvider>
                    </div>
                  </v-col>
                </v-row>

                <v-row class="ma-0 mb-15">
                  <v-col class="pa-0">
                    <h2 class="nec_title mb-15"><i>*</i> {{ $t('signin.proof_document.fields.id_card_or_passport') }}</h2>
                    <div class="input_text_type_basic file_type">
                      <ValidationProvider v-slot="{ errors }" :name="$t('signin.proof_document.fields.id_card_or_passport')" :rules="{required: true}">
                        <v-file-input
                          outlined
                          dense
                          :placeholder="$t('common.common.no_files_selected')"
                          :prepend-icon="$t('common.common.select_file')"
                          class="ft-size12 br_none"
                          accept=".pdf, .jpg, .gif"
                          v-model="id_card_file"
                          style="height: 40px"
                          @change="fnUploadIdFile()"
                          clearable
                          @click:clear="fnInitIdFile()"
                          :error-messages="errors"
                        >
                        </v-file-input>
                      </ValidationProvider>
                    </div>
                  </v-col>
                </v-row>

                <v-row class="ma-0 mb-15" v-if="user_type_code === '2705'">
                  <v-col class="pa-0">
                    <h2 class="nec_title mb-15"><i>*</i> {{ $t('signin.proof_document.fields.student_id_card') }}</h2>
                    <div class="input_text_type_basic file_type">
                      <ValidationProvider v-slot="{ errors }" :name="$t('signin.proof_document.fields.student_id_card')" :rules="{required: true}">
                        <v-file-input
                          outlined
                          dense
                          :placeholder="$t('common.common.no_files_selected')"
                          :prepend-icon="$t('common.common.select_file')"
                          class="ft-size12 br_none"
                          accept=".pdf, .jpg, .gif"
                          v-model="student_id_file"
                          style="height: 40px"
                          @change="fnUploadStudentIdFile()"
                          :error-messages="errors"
                        >
                        </v-file-input>
                      </ValidationProvider>
                    </div>
                  </v-col>
                </v-row>
              </v-form>
            </ValidationObserver>
          </v-card-text>
          <v-card-actions class="pa-30">
            <v-spacer></v-spacer>
            <v-btn
              dense
              height="50"
              width="150"
              dark
              color="#2a58ad"
              class="btn-normal br_none"
              @click="fnSave()"
            >
              {{ $t('common.button.submit') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-dialog>
</template>

<script>
import requestApi from '@/utils/requestApi'
import utils from '@/utils/utils'
import eventBus from '@/utils/eventBus'
import store from '@/store'
import { ValidationObserver, ValidationProvider } from 'vee-validate'

export default {
  components :{
    ValidationObserver,
    ValidationProvider
  },
  data () {
    return {
      user_group_type_code : store.state.token.user_group_type_code,
      user_type_code: store.state.token.user_type_code,

      dialog_proof : false,

      id_card_file : null,
      id_card_file_key : '',

      student_id_file: null,
      student_id_file_key: '',

      company_reg_file : null,
      registry_cert_file_key : '',
    }
  },
  watch: {
    dialog_proof(val) {
      if (val) {
        this.id_card_file = null
        this.id_card_file_key = ''

        this.student_id_file = null
        this.student_id_file_key = ''

        this.company_reg_file = null,
        this.registry_cert_file_key = ''
      }
    }
  },
  mounted () {
    this.id_card_file = null
    this.id_card_file_key = ''

    this.student_id_file = null
    this.student_id_file_key = ''

    this.company_reg_file = null,
    this.registry_cert_file_key = ''
  },
  methods: {
    fnSave(){
      this.$refs.observer.validate().then((valid) => {
        if(valid){
          let params = {
            id_card_file_key : this.id_card_file_key,
            student_id_file_key: this.student_id_file_key,
            registry_cert_file_key: this.registry_cert_file_key
          }

          requestApi({
            url: '/user/profile/proof',
            method: 'PUT',
            data : params,
            callback: (res) => {
              if (res.res_code === '200') {

                store.dispatch('SetUserStatusTypeCode', res.data.user_status_type_code)
                this.$emit('success')
                this.dialog_proof = false
              }else{
                if (res.res_code === '401012') {
                  utils.setTokenRefresh().then(() => {
                    this.fnSave()
                  })
                } else {
                  eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
                }
              }
            }
          })
        } else {
          //2020-11-03 : 첫번째 에러 항목으로 Focus 되도록 추가 수정 (vee-validate 3.0 기반)
          document.getElementsByClassName('error--text')[0].scrollIntoView(false)
        }
      })
    },
    fnInitCompanyRegFile() {
      this.registry_cert_file_key = ''
      this.company_reg_file = null
    },

    fnUploadCompanyRegFile(){
      if(!utils.isNull(this.company_reg_file)){
        let extList = []
        extList.push({name_en: 'pdf'})
        extList.push({name_en: 'jpg'})
        extList.push({name_en: 'gif'})

        if (utils.getFileExtLen(this.company_reg_file, extList, this.$t('common.message.file_extension_error')) === -1) {
          setTimeout(() => {
            this.company_reg_file = null
            this.registry_cert_file_key = ''
          }, 100)

          return
        }

        let formData = new FormData()
        formData.append("file_data", this.company_reg_file)

        requestApi({
          url: '/file/documents/upload',
          method: 'POST',
          data: formData,
          headers : {"Content-Type":"multipart/form-data"},
          callback: (res) => {
            // 파일저장
            if (res.res_code === '200') {
              this.registry_cert_file_key = res.data.file_key
            }else{
              if (res.res_code === '401012') {
                utils.setTokenRefresh().then(() => {
                  this.fnUploadCompanyRegFile()
                })
              } else {
                eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
                this.registry_cert_file_key = ''
                this.company_reg_file = null
              }
            }
          }
        })
      }
    },
    fnInitIdFile() {
      this.id_card_file_key = ''
      this.id_card_file = null
    },

    fnUploadIdFile(){
      if(!utils.isNull(this.id_card_file)){
        let extList = []
        extList.push({name_en: 'pdf'})
        extList.push({name_en: 'jpg'})
        extList.push({name_en: 'gif'})

        if (utils.getFileExtLen(this.id_card_file, extList, this.$t('common.message.file_extension_error')) === -1) {
          setTimeout(() => {
            this.id_card_file_key = ''
            this.id_card_file = null
          }, 100)

          return
        }

        let formData = new FormData()
        formData.append("file_data", this.id_card_file)

        requestApi({
          url: '/file/documents/upload',
          method: 'POST',
          data: formData,
          headers : {"Content-Type":"multipart/form-data"},
          callback: (res) => {
            // 파일저장
            if (res.res_code === '200') {
              this.id_card_file_key = res.data.file_key
            }else{
              if (res.res_code === '401012') {
                utils.setTokenRefresh().then(() => {
                  this.fnUploadIDFile()
                })
              } else {
                eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
                this.id_card_file_key = ''
                this.id_card_file = null
              }
            }
          }
        })
      }
    },

    fnUploadStudentIdFile(){
      if(!utils.isNull(this.student_id_file)){
        let extList = []
        extList.push({name_en: 'pdf'})
        extList.push({name_en: 'jpg'})
        extList.push({name_en: 'gif'})

        if (utils.getFileExtLen(this.student_id_file, extList, this.$t('common.message.file_extension_error')) === -1) {
          setTimeout(() => {
            this.student_id_file_key = ''
            this.student_id_file = null
          }, 100)

          return
        }

        let formData = new FormData()
        formData.append("file_data", this.student_id_file)

        requestApi({
          url: '/file/documents/upload',
          method: 'POST',
          data: formData,
          headers : {"Content-Type":"multipart/form-data"},
          callback: (res) => {
            // 파일저장
            if (res.res_code === '200') {
              this.student_id_file_key = res.data.file_key
            }else{
              if (res.res_code === '401012') {
                utils.setTokenRefresh().then(() => {
                  this.fnUploadStudentIdFile()
                })
              } else {
                eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
                this.student_id_file_key = ''
                this.student_id_file = null
              }
            }
          }
        })
      }
    },

    fnClose(){
      this.dialog_proof = false
    }


  }
}
</script>